import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Menubar } from 'primereact/menubar';

const StaticPageLayout = ({ children }) => {
    const navigate = useNavigate();

    const navigateToInterestng = () => {
        window.location.href = 'https://app.interestng.com/app/login';
    };

    const menuItems = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/app')
        },
        {
            label: 'About Us',
            icon: 'pi pi-info-circle',
            command: () => navigate('/app/about')
        },
        {
            label: 'Contact',
            icon: 'pi pi-envelope',
            command: () => navigate('/app/contact')
        },
        {
            label: 'Legal',
            icon: 'pi pi-briefcase',
            items: [
                {
                    label: 'Privacy Policy',
                    icon: 'pi pi-shield',
                    command: () => navigate('/app/privacy-policy')
                },
                {
                    label: 'Terms & Conditions',
                    icon: 'pi pi-file',
                    command: () => navigate('/app/terms-and-conditions')
                },
                {
                    label: 'Refund Policy',
                    icon: 'pi pi-refresh',
                    command: () => navigate('/app/refund-policy')
                }
            ]
        }
    ];

    const start = (
        <Link to="/app" className="flex align-items-center" aria-label="Go to Home">
            <img src={`${process.env.PUBLIC_URL}/layout/images/interestng_logo_updated.jpeg`} alt="INTERESTNG" height="40" className="logo-image" style={{width: 'auto', mixBlendMode: 'multiply', filter: 'contrast(1.1) brightness(1.05)'}} />
        </Link>
    );

    const end = (
        <Button 
            label="Get Started" 
            icon="pi pi-arrow-right" 
            className="p-button-raised"
            onClick={navigateToInterestng}
        />
    );

    return (
        <div className="min-h-screen flex flex-column">
            {/* Professional Header */}
            <header className="surface-0 border-bottom-1 surface-border sticky top-0 z-5 shadow-2">
                <div className="px-2 md:px-3 lg:px-6">
                    <Menubar 
                        model={menuItems} 
                        start={start} 
                        end={end}
                        className="border-none surface-0"
                        style={{ borderRadius: '0' }}
                    />
                </div>
            </header>

            {/* Main Content - Full Width */}
            <main className="flex-grow-1 surface-ground">
                {children}
            </main>

            {/* Professional Footer */}
            <footer className="bg-gray-900 text-gray-100 mt-auto">
                <div className="px-4 py-6 lg:px-8">
                    <div className="grid">
                        {/* Company Info */}
                        <div className="col-12 lg:col-3 pr-0 lg:pr-5 mb-4 lg:mb-0">
                            <h3 className="text-white font-bold mb-3 md:mb-4 text-lg md:text-xl">
                                <img src={`${process.env.PUBLIC_URL}/layout/images/interestng_logo_updated.jpeg`} alt="INTERESTNG" height="36" className="mr-2" style={{ display: 'inline-block', verticalAlign: 'middle', width: 'auto', mixBlendMode: 'multiply', filter: 'contrast(1.1) brightness(1.05)' }} />
                            </h3>
                            <p className="text-gray-400 line-height-3 mb-3 md:mb-4 text-sm md:text-base">
                                Simplifying credit bureau reports and financial verification services for businesses across India. 
                                Your trusted partner for loan origination and verification needs.
                            </p>
                            
                        </div>

                        {/* Quick Links */}
                        <div className="col-12 md:col-6 lg:col-2 mb-4 md:mb-0">
                            <h4 className="text-white font-semibold mb-3 text-center md:text-left">Company</h4>
                            <ul className="list-none p-0 m-0 text-center md:text-left">
                                <li className="mb-2">
                                    <Link to="/app" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Home
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/app/about" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        About Us
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/app/contact" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Contact
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/register" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Get Started
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        {/* Services */}
                        <div className="col-12 md:col-6 lg:col-2 mb-4 lg:mb-0">
                            <h4 className="text-white font-semibold mb-3 text-center md:text-left">Our Services</h4>
                            <ul className="list-none p-0 m-0 text-center md:text-left">
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-check-circle mr-2 text-primary text-xs"></i>
                                    Loan comparision tools
                                </li>
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-check-circle mr-2 text-primary text-xs"></i>
                                    Credit Bureau Reports
                                </li>
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-check-circle mr-2 text-primary text-xs"></i>
                                    Bank Statement Analysis
                                </li>
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-check-circle mr-2 text-primary text-xs"></i>
                                    Employment History
                                </li>
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-check-circle mr-2 text-primary text-xs"></i>
                                    Document Verification
                                </li>
                            </ul>
                        </div>

                        {/* Contact Info */}
                        <div className="col-12 md:col-6 lg:col-2">
                            <h4 className="text-white font-semibold mb-3 text-center lg:text-left">Contact Info</h4>
                            <ul className="list-none p-0 m-0 text-center lg:text-left">
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-map-marker mr-2 text-primary"></i>
                                    Banashankari, Bengaluru - 560070
                                </li>
                                <li className="mb-2 text-gray-400 text-sm">
                                    <i className="pi pi-envelope mr-2 text-primary"></i>
                                    tech@interestng.com
                                </li>
                            </ul>
                        </div>
                        
                        {/* Legal */}
                        <div className="col-12 md:col-6 lg:col-2">
                            <h4 className="text-white font-semibold mb-3 text-center lg:text-left">Legal</h4>
                            <ul className="list-none p-0 m-0 text-center lg:text-left">
                                <li className="mb-2">
                                    <Link to="/app/privacy-policy" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/app/terms-and-conditions" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Terms & Conditions
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link to="/app/refund-policy" className="text-gray-400 hover:text-primary transition-colors transition-duration-300 no-underline text-sm">
                                        Refund Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Bottom Bar */}
                    <div className="border-top-1 border-gray-800 mt-5 pt-4">
                        <div className="flex flex-column md:flex-row justify-content-between align-items-center text-center md:text-left">
                            <p className="text-gray-500 text-xs md:text-sm m-0">
                                © {new Date().getFullYear()} Interestng by Hireka Services Pvt. Ltd. All rights reserved.
                            </p>
                            <div className="flex align-items-center gap-3 mt-2 md:mt-0">
                                <span className="text-gray-500 text-xs md:text-sm">
                                    Made with <i className="pi pi-heart-fill text-red-400"></i> in India
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default StaticPageLayout;